import { render, staticRenderFns } from "./PortAdminOverlay.vue?vue&type=template&id=c0457c76&scoped=true"
import script from "./PortAdminOverlay.vue?vue&type=script&lang=js"
export * from "./PortAdminOverlay.vue?vue&type=script&lang=js"
import style0 from "./PortAdminOverlay.vue?vue&type=style&index=0&id=c0457c76&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c0457c76",
  null
  
)

export default component.exports